import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";

export interface AdminUser {
  id: string;
  name?: string;
  email: string;
  profilePictureLink?: string;
  linkedIn?: string;
  phoneNumber?: string;
  marketingConsent: boolean;
  isAdmin: boolean;
}

export const useAdminUsersQuery = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { data, error, isLoading } = useQuery({
    queryKey: QueryKeys.adminUsers,
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return await request<AdminUser[]>({
        method: "GET",
        path: "/api/admin/users",
        token,
      });
    },
  });

  return {
    adminUsers: data,
    adminUsersError: error,
    adminUsersLoading: isLoading,
  };
};
